// extracted by mini-css-extract-plugin
export var filterIncDec = "_4d-0";
export var leftBorder = "_4d-1";
export var rightBorder = "_4d-2";
export var stringInput = "_4d-3";